import { visibleButton } from "../include/module";
import { anchorLink } from "../include/module";



const breakPointPC = 1279;
const breakPointSP = 767;
let resizeFlag     = false;
let windowWidth    = window.innerWidth;
let windowHeight   = window.innerHeight;
let windowWidthJ   = $(window).width();



// ------------------------------------------------------------------------
// loadContents
// ----- BOTH
// ------------------------------------------------------------------------
const loadContents = () => {

 let loadContents     = document.querySelector('.idx-Load');
 let mainContents     = document.querySelector('.idx-Main');
 let campaignContents = document.querySelector('.idx-Campaign');

 window.addEventListener('load', () => {
   setTimeout(() => {
     loadContents.classList.add('is-Loaded');
     mainContents.classList.add('is-Loaded');
     campaignContents.classList.add('is-Loaded');
   }, 2000);
   setTimeout(() => {
     loadContents.parentNode.removeChild(loadContents);
   }, 6000);
 });

}



// ------------------------------------------------------------------------
// setSlider
// ----- BOTH
// ------------------------------------------------------------------------
const setSlider = () => {

 let sliderImageWidth;
 let sliderExtraWidth;
 let sliderObject;

 if (windowWidth > breakPointPC) {
   sliderImageWidth = windowWidth * 0.5;
   sliderExtraWidth = (windowWidth - sliderImageWidth) / 2;
 } else if (windowWidth <= breakPointPC && windowWidth > breakPointSP) {
   sliderImageWidth = windowWidth * 0.75;
   sliderExtraWidth = (windowWidth - sliderImageWidth) / 2;
 } else {
   sliderImageWidth = windowWidth * 0.78125;
   sliderExtraWidth = (windowWidth - sliderImageWidth) / 2;
 }

 sliderObject = $('.idx-Main_Slider_List').slick({
   speed: 600,
   autoplay: true,
   autoplaySpeed: 4000,
   infinite: true,
   dots: true,
   arrows: true,
   slidesToShow: 1,
   centerMode: true,
   centerPadding: sliderExtraWidth + 'px',
 });

 window.addEventListener('load', () => {
   $('.idx-Main_Slider_List').addClass('slick-ready');
 });

 window.addEventListener('resize', () => {
   let resizeWidth = window.innerWidth;
   let sliderResizeWidth;
   let sliderExtraResizeWidth;
   if (resizeWidth > breakPointPC) {
     sliderResizeWidth = resizeWidth * 0.5;
     sliderExtraResizeWidth = (resizeWidth - sliderResizeWidth) / 2;
   } else if (resizeWidth <= breakPointPC && resizeWidth > breakPointSP) {
     sliderResizeWidth = resizeWidth * 0.75;
     sliderExtraResizeWidth = (resizeWidth - sliderResizeWidth) / 2;
   } else {
     sliderResizeWidth = resizeWidth * 0.78125;
     sliderExtraResizeWidth = (resizeWidth - sliderResizeWidth) / 2;
   }
   sliderObject[0].slick.options.centerPadding = sliderExtraResizeWidth + 'px';
 });

}



// ------------------------------------------------------------------------
// animateFade
// ----- BOTH
// ------------------------------------------------------------------------
const animateFade = () => {

 $(window).on('scroll', function(){
   $('.anime-Fade').each(function(){
     var imagePosition = $(this).offset().top;
     var scrollVolume  = $(window).scrollTop();
     var windowWidth   = $(window).width();
     var windowHeight  = $(window).height();
     if(windowWidth > breakPointSP){
       if(scrollVolume > imagePosition - windowHeight + windowHeight / 3.25){
         $(this).addClass('anime-Fade-On');
       }
     } else {
       if(scrollVolume > imagePosition - windowHeight + windowHeight / 4){
         $(this).addClass('anime-Fade-On');
       }
     }
   })
 });

}



(() => {
  loadContents();
  setSlider();
  animateFade();
  visibleButton();
  anchorLink();
})();



// WEBPACK FOOTER //
// script.js